<div class="content-wrapper">
  <section class="content">
      <div class="box">
          <div class="box-body">
              <form [formGroup]="WaiveOffCreationForm" (ngSubmit)="SaveWaveOff()">                  
                  <fieldset>
                      <div class="panel panel-default">
                          <header class="panel-heading">
                              <h5 class="panel-title">Waive Off</h5>
                          </header>
                          <div class="panel-body">
                              <div class="row">
                                  <div class="form-group col-md-2">
                                      <label class="required">Waive Off Type</label>
                                  </div>
                                      <div class="form-group col-md-4">
                                          <mat-radio-group formControlName="IsFullWaiveOff" required (change)="ValidationMessage();">
                                              <mat-radio-button  value="0">Partial
                                              </mat-radio-button>
                                              <mat-radio-button value="1">Full</mat-radio-button>
                                          </mat-radio-group>
                                          <mat-error
                                        *ngIf="GetFormControls('IsFullWaiveOff').invalid && (GetFormControls('IsFullWaiveOff').dirty || GetFormControls('IsFullWaiveOff').touched)"
                                        class="ValidationError">
                                        <mat-error *ngIf="GetFormControls('IsFullWaiveOff').errors.required">
                                          Please Select Waive Off Type.
                                        </mat-error>
                                      </mat-error>
                                      </div>
                                  </div>                             
                              <br>
                              <div class="row">
                                  <div class="form-group col-md-5">
                                      <label class="required">Remarks</label>
                                  
                                      <input class="form-control"  maxlength="200" placeholder=" remarks"
                                        formControlName="Remarks" appPreventSpecialChars >
                                      <mat-error
                                        *ngIf="GetFormControls('Remarks').invalid && (GetFormControls('Remarks').dirty || GetFormControls('Remarks').touched)"
                                        class="ValidationError">
                                        <mat-error *ngIf="GetFormControls('Remarks').errors.required">
                                          Remarks is required.
                                        </mat-error>
                                      </mat-error>
                                  </div>
                                  <div class="form-group col-md-3">
                                      &nbsp; &nbsp; <label class="required">Supporting Document</label>
                                    </div>
                                    <div class="form-group col-md-4">
                                      <input type="file" style="display: inline" accept=".xlsx,.msg,.docx,.pdf,.zip" (change)="onfilechange($event)">
                                     <span style="color: dodgerblue">{{showAttachmentName}}</span> 
                                      <mat-error
                                      *ngIf="GetFormControls('FilePath').invalid && (GetFormControls('FilePath').dirty || GetFormControls('FilePath').touched)"
                                      class="ValidationError">
                                      <mat-error *ngIf="GetFormControls('FilePath').errors.required">
                                       Supporting Document is required.
                                      </mat-error>
                                      </mat-error>
                                    </div>
                                    
                              </div>        
                              <div class="row">
                                  <div class="form-group col-md-5">
                                      <label class="required">Original Penalty Amount</label>
                                  
                                      <input class="form-control" readonly  maxlength="200" placeholder=" original penalty amount"
                                        formControlName="OriginalPenaltyAmount" >
                                      <mat-error
                                        *ngIf="GetFormControls('OriginalPenaltyAmount').invalid && (GetFormControls('OriginalPenaltyAmount').dirty || GetFormControls('OriginalPenaltyAmount').touched)"
                                        class="ValidationError">
                                        <mat-error *ngIf="GetFormControls('OriginalPenaltyAmount').errors.required">
                                            Original Penalty Amount is required.
                                        </mat-error>
                                      </mat-error>
                                  </div>
                                  <div class="form-group col-md-5">
                                      <label class="required">Waive Off Amount</label>                                 
                                      <input class="form-control"  maxlength="200" placeholder=" waive off amount"
                                        formControlName="WaiveOffAmount" maxlength="10" appTwoDigitDecimaNumber onpaste="return false" [readonly]='IsWaiveAmountEnable' (change)="ValidationMessage();">
                                      <mat-error
                                        *ngIf="GetFormControls('WaiveOffAmount').invalid && (GetFormControls('WaiveOffAmount').dirty || GetFormControls('WaiveOffAmount').touched)"
                                        class="ValidationError">
                                        <mat-error *ngIf="GetFormControls('WaiveOffAmount').errors.required">
                                          Wave Off Amount is required.
                                        </mat-error>
                                      </mat-error>
                                  </div>
                              </div> 
                              <div class="row">
                                  <div class="form-group col-md-5">
                                      <label class="required">Net Recovery Amount</label>
                                 
                                      <input class="form-control"   maxlength="12" placeholder=" net recovery amount"
                                        formControlName="NetRecoveryAmount" onpaste="return false" readonly >
                                      <mat-error
                                        *ngIf="GetFormControls('NetRecoveryAmount').invalid && (GetFormControls('NetRecoveryAmount').dirty || GetFormControls('NetRecoveryAmount').touched)"
                                        class="ValidationError">
                                        <mat-error *ngIf="GetFormControls('NetRecoveryAmount').errors.required">
                                          Net Recovery Amount is required.
                                        </mat-error>
                                      </mat-error>
                                  </div>
                              </div>                                             
                          </div>
                      </div>
                  </fieldset>
                  <mat-card class="btnCard" style="text-align: right">
                      <button type="submit" *ngIf="_global.IsAdmin || _global.IsLocationSPOC"
                          mat-stroked-button>{{btnValue}}</button>
                      <button type="button" *ngIf="_global.IsAuditVisible" mat-stroked-button
                          (click)="openAuditTrailDialog()" style="display: none">Audit Trail</button>
                      <button type="button" mat-stroked-button [mat-dialog-close]="true">Close</button>
                  </mat-card>
              </form>
          </div>
      </div>
  </section>
</div>